package nl.volleyplanner.lib

@JsModule("@js-joda/timezone/dist/js-joda-timezone-1970-2030.js")
@JsNonModule
external object JsJodaTimeZoneModule

val jsJodaTz = JsJodaTimeZoneModule